import { makeStyles } from "@material-ui/core";


export default makeStyles((theme) => ({
    buttonSkeleton: {
        height: 50,
        width: 50,
        marginRight: 16,
    },
    dot: {
        height: 8,
        width: 8,
        marginRight: 8,
        backgroundColor: theme.palette.error.main,
        borderRadius: "50%",
    },
    liveText: {
        fontWeight: "bold",
        color: theme.palette.error.main,
    },
    toolbar: {
        height: 76,
        position: "relative",
        display: "grid",
        gridTemplateColumns: "auto 7em",
    },
    footerMiddle: {
        display: "grid",
        justifyContent: "center",
        paddingRight: "1.5em",
        gridTemplateColumns: "auto 7em",
    },
    footerRight: {
        minWidth: "8em",
    },
    goLive: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.error.dark,
        },
    },
    link: {
        textDecoration: "none",
    },
}));
